import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Legend, Tooltip);

// Manually defined background colors
const backgroundColors = [
  '#F8D66D',   // Cash Over Short
  '#7ABD7E',    // Cash Paid
  '#9369A9',    // Sales
  '#D15D69',    // Discounts
  '#ED9F6D',    // Food Cost
  // Add more colors here as needed
];

const borderColors = [
 '#F8D66D',   // Cash Over Short
  '#7ABD7E',    // Cash Paid
  '#9369A9',    // Sales
  '#D15D69',    // Discounts
  '#ED9F6D', 
];

const LineChart = ({ labels = [], datasets = [] }) => {
  const data = {
    labels,
    datasets: datasets.map((ds, index) => ({
      ...ds,
      borderColor: borderColors[index] || 'rgba(0,0,0,1)',
      backgroundColor: backgroundColors[index] || 'rgba(0,0,0,0.1)',
      fill: true,
      tension: 0.3,
      pointRadius: 4,
      pointHoverRadius: 6,
    })),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      y: {
        beginAtZero: false,
        ticks: {
          color: '#333',
        },
      },
      x: {
        ticks: {
          color: '#333',
        },
      },
    },
  };

  return (
    <div className="w-full h-[400px] md:h-[450px] lg:h-[500px]">
      <Line data={data} options={options} />
    </div>
  );
};

export default LineChart;
